var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{ref:"dialog",attrs:{"title":"新增客户","visible":_vm.addShow,"close-on-click-modal":false,"width":"750px","top":"5vh"},on:{"update:visible":function($event){_vm.addShow=$event},"close":_vm.editorClose}},[_c('AddCustomer',{ref:"addCustomer",on:{"confirmSeasFun":_vm.onModalSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }